/**
 * @module Components
 *
 */
import React, { PropsWithChildren } from "react";
import { cls } from "app/utils";
import { Dots } from "app/components/Loading";
import Footer from "./Footer";
import styles from "./styles.module.scss";
import logo_png from "app/images/coachnow_black_text_logo.svg";
import onboarding_devices from "app/images/onboarding-devices-cropped.png";
import { useTranslation } from "react-i18next";

type PropsDef = PropsWithChildren<{
  loading?: boolean;
  header?: JSX.Element;
  // Replaces the default "Welcome to CoachNow" right panel for steps that
  // need their own side content (e.g. the athlete invite dead end).
  sideContent?: JSX.Element;
  // Widens the content column for steps with side-by-side option cards; the
  // regular form steps keep the narrow column.
  wide?: boolean;
}>;

export default function Wrapper(props: PropsDef) {
  const { t } = useTranslation();
  const body = props.loading ? (
    <Dots className={styles.dots_wrapper} active={true} />
  ) : (
    <div
      className={cls(styles.wrapper_content, {
        [styles.wrapper_content_wide]: props.wide,
      })}
    >
      {props.children}
    </div>
  );

  const footer = props.loading ? <div /> : <Footer />;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_body}>
        <div className={styles.wrapper_body_content}>
          <a className={styles.wrapper_link} href={window.location.origin}>
            <img className={styles.logo_img} src={logo_png} />
          </a>

          {props.header && props.header}
          {body}
        </div>
        {footer}
      </div>
      <div className={styles.right_content}>
        {props.sideContent != null ? (
          <div className={styles.side_custom}>{props.sideContent}</div>
        ) : (
          <div className={styles.right_body}>
            <div className={styles.onboarding_description_wrapper}>
              <div className={styles.onboarding_desc_container}>
                <h1 className={styles.onboarding_title}>
                  {t("Welcome to CoachNow")}
                </h1>
                <p className={styles.onboarding_description}>
                  {t(
                    "The world's best coaches, academies, and national programs in 60+ sports across 140 countries rely on CoachNow every day to stay connected & coach their athletes.",
                  )}
                </p>
              </div>
            </div>
            <img
              src={onboarding_devices}
              alt="onboarding"
              className={styles.onboarding_img}
            />
          </div>
        )}
      </div>
    </div>
  );
}
